export const DESCRIPTION = 'Official app - free';
export const DESCRIPTION_V1 = 'Explore it all';
export const CTA_BUTTON_TEXT = 'Get the app';
export const CTA_LINK_HOMEAWAY = 'https://t.hmwy.io/6WIuXZNLf6';
export const CTA_LINK_VRBO = 'https://t.vrbo.io/9t5qCBXLf6';
export const HOMEAWAY = 'HomeAway';
export const RATING = '592.8k';
export const RATING_TEXT = 'Ratings';
export const STARS = 4.8;
export const TITLE = 'Get Vrbo on the go!';
export const TITLE_V1 = 'It\'s even better in the Vrbo app';
export const VRBO = 'Vrbo';
export const HOMEAWAY_SITE = 'homeaway_us';
export const MODAL_CLOSE_BUTTON_TEXT = 'Not Yet';
export const BRANCH_KEY = 'key_live_nirBKlMulpVhZT1Rue3YsebcAAlgafLk';
export const BRANCH_SRC = 'https://cdn.branch.io/branch-latest.min.js';
